/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react'
import { Redirect, Route, Switch, useLocation } from 'react-router-dom'
import { ForgotPassword } from './components/ForgotPassword'
import { ConfirmOtp } from './components/ConfirmOtp'
import { Login } from './components/Login'
import { toAbsoluteUrl } from '../../../_template/helpers'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from '../../../setup'
import { AuthModel } from './models/AuthModel'
import { ForgotPasswordRenew } from './components/ForgotPasswordRenew'
import { PasswordExpiredRenew } from './components/PasswordExpiredRenew'

export function AuthPage() {
  const accessToken = useSelector<RootState>(({ auth }) => auth.accessToken, shallowEqual) as AuthModel | undefined
  const waitingOtp = (accessToken !== undefined && (accessToken as AuthModel).token_policy === "otpwaiting");
  const passwordExpired = (accessToken !== undefined && (accessToken as AuthModel).token_policy === "passwordexpired");

  const { pathname } = useLocation()
  const publicPageRegex = new RegExp("\/public\/");
  const publicPage = publicPageRegex.test(pathname)
  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])

  return (
    <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
      style={{
        backgroundImage: `url(${toAbsoluteUrl('/media/illustrations/sketchy-1/14.png')})`, height: '100vh',
      }}
    >
      {/* begin::Content */}
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
        {/* begin::Logo */}
        <a href='#' className='mb-12'>
          <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo-1.png')} className='h-45px' />
        </a>
        {/* end::Logo */}
        {/* begin::Wrapper */}
        <div className='w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto'>
          <Switch>
            <Route path='/auth/login' component={Login} />
            <Route path='/auth/otp' component={ConfirmOtp} />
            <Route path='/auth/passwordexpired' component={PasswordExpiredRenew} />
            <Route path='/auth/forgot-password' component={ForgotPassword} />
            <Route path='/public/password-renew' component={ForgotPasswordRenew} />
            <Redirect from='/auth' exact={true} to='/auth/login' />
            {
              publicPage ? (
                <></>
              ) :
                waitingOtp ? (
                  <Redirect to='/auth/otp' />
                ) :
                  passwordExpired ? (
                    <Redirect to='/auth/passwordexpired' />
                  ) :
                    (
                      <Redirect to='/auth/login' />
                    )
            }
          </Switch>
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
    </div>
  )
}
